var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewSettlement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-business-deal",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    svg#freepik_stories-business-deal:not(.animated) .animable {\n      opacity: 0;\n    }\n\n    svg#freepik_stories-business-deal.animated #freepik--background-complete--inject-2 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) fadeIn;\n      animation-delay: 0s;\n    }\n\n    svg#freepik_stories-business-deal.animated #freepik--Floor--inject-2 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0s;\n    }\n\n    svg#freepik_stories-business-deal.animated #freepik--Characters--inject-2 {\n      animation: 1.5s Infinite linear wind;\n      animation-delay: 0s;\n    }\n\n    svg#freepik_stories-business-deal.animated #freepik--Plants--inject-2 {\n      animation: 1s 1 forwards cubic-bezier(.36, -0.01, .5, 1.38) slideUp;\n      animation-delay: 0s;\n    }\n\n    svg#freepik_stories-business-deal.animated #freepik--speech-bubble--inject-2 {\n      animation: 1.5s Infinite linear heartbeat;\n      animation-delay: 0s;\n    }\n\n    @keyframes fadeIn {\n      0% {\n        opacity: 0;\n      }\n\n      100% {\n        opacity: 1;\n      }\n    }\n\n    @keyframes slideUp {\n      0% {\n        opacity: 0;\n        transform: translateY(30px);\n      }\n\n      100% {\n        opacity: 1;\n        transform: inherit;\n      }\n    }\n\n    @keyframes wind {\n      0% {\n        transform: rotate(0deg);\n      }\n\n      25% {\n        transform: rotate(1deg);\n      }\n\n      75% {\n        transform: rotate(-1deg);\n      }\n    }\n\n    @keyframes heartbeat {\n      0% {\n        transform: scale(1);\n      }\n\n      10% {\n        transform: scale(1.1);\n      }\n\n      30% {\n        transform: scale(1);\n      }\n\n      40% {\n        transform: scale(1);\n      }\n\n      50% {\n        transform: scale(1.1);\n      }\n\n      60% {\n        transform: scale(1);\n      }\n\n      100% {\n        transform: scale(1);\n      }\n    }\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2",
    className: "animable",
    style: {
      transformOrigin: "244.703px 255.515px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.68,303.35s9-3,13.32,17.82,5,32.27,5,32.27,1.42,4.49,4.72,2.71,8.84-7.89,13-5.39,4.38,8.17,1.42,15.52S77.22,390,76.7,391.44s-.27,3.87,2.18,3,17.91-10.82,22.2-3.2-7.3,26.75-8.53,28.86-1,3.21-.12,4.07,5.81-3,10.33-5.63,10.21-4.95,12.32-.34-1.14,20.44-22.86,41.67l-10.71,9.19-13.43-4.49c-28.18-11.35-37.22-24.75-37-29.81s6.34-5.12,11.52-4.38,11.17,2.42,11.7,1.27.28-2.23-1.67-3.72-20-14.74-18.89-23.42,19.16-5.37,21.74-5.51,1.9-2.48.87-3.62-12.72-14-18.26-19.7-7.55-10.87-4.6-14.89,10.3-.34,14,.05,3.33-4.31,3.33-4.31-3.77-10.87-7.71-31.72,5.76-21.53,5.76-21.53",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "73.352px 386.13px"
    },
    id: "elhov61hfe2mo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.59,466.11c-3-15.31-7.2-36.42-12-59.73S60.53,362,57.5,346.7c-1.5-7.63-2.73-13.81-3.57-18.11-.42-2.12-.75-3.78-1-4.92-.12-.55-.2-1-.27-1.28s-.1-.44-.1-.44,0,.16.05.45.13.73.22,1.28c.21,1.15.51,2.82.89,4.94.78,4.29,1.95,10.49,3.43,18.14,2.94,15.31,7.2,36.42,12,59.72s9.08,44.41,12.11,59.7",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "67.075px 394.065px"
    },
    id: "elkc2c5zp2c2f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.24,359.61a4.71,4.71,0,0,0-.6.82c-.36.55-.86,1.36-1.47,2.36-1.22,2-2.82,4.82-4.53,7.95l-4.34,8.05L65,381.23a4.68,4.68,0,0,0-.45.91,3.57,3.57,0,0,0,.61-.82c.36-.54.87-1.35,1.46-2.36,1.2-2,2.76-4.85,4.47-8l4.4-8c.53-.95,1-1.76,1.34-2.43A4.12,4.12,0,0,0,77.24,359.61Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "70.895px 370.875px"
    },
    id: "el9msl1uk0bxt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.21,382c.07-.11-5.59-3.67-12.62-8s-12.81-7.66-12.88-7.55,5.58,3.68,12.62,8S63.14,382.16,63.21,382Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "50.46px 374.226px"
    },
    id: "el31ozw7ijbkn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.15,417.5a4.21,4.21,0,0,0-1-.33l-2.73-.74c-2.3-.63-5.48-1.51-9-2.61s-6.59-2.17-8.83-3L48,409.89a4.59,4.59,0,0,0-1-.3,4.3,4.3,0,0,0,.93.47c.61.28,1.5.66,2.61,1.1,2.23.89,5.33,2,8.82,3.13s6.69,1.92,9,2.47c1.17.27,2.11.47,2.77.59A4.38,4.38,0,0,0,72.15,417.5Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "59.575px 413.545px"
    },
    id: "elces5oj9ibhk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.32,400a3.92,3.92,0,0,0-.75.61c-.46.42-1.11,1-1.91,1.79-1.6,1.53-3.78,3.66-6.17,6S76,413,74.41,414.57c-.76.79-1.38,1.44-1.8,1.9a3.6,3.6,0,0,0-.61.74,3.78,3.78,0,0,0,.75-.61c.45-.41,1.11-1,1.9-1.79,1.6-1.52,3.79-3.66,6.18-6s4.53-4.55,6.07-6.14c.77-.79,1.38-1.44,1.8-1.9A4,4,0,0,0,89.32,400Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "80.66px 408.605px"
    },
    id: "elzvjd7txtf4m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.19,430.3a5.92,5.92,0,0,0-1,.79l-2.45,2.28c-2.06,1.95-4.88,4.66-8,7.68s-5.88,5.76-7.87,7.77l-2.35,2.4a6.55,6.55,0,0,0-.82.92,6.1,6.1,0,0,0,1-.79l2.46-2.29c2-1.94,4.87-4.65,8-7.67S96,435.63,98,433.62l2.35-2.4A6.8,6.8,0,0,0,101.19,430.3Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "89.945px 441.22px"
    },
    id: "eltlvjba0ztgt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.17,451.47a7,7,0,0,0-1.24-.45L74.5,450c-2.89-.9-6.89-2.16-11.26-3.67s-8.29-3-11.13-4L48.75,441a7.31,7.31,0,0,0-1.25-.41,7.17,7.17,0,0,0,1.18.59c.77.35,1.9.83,3.31,1.41,2.8,1.16,6.71,2.67,11.1,4.18s8.39,2.72,11.31,3.53c1.47.41,2.65.72,3.48.92A7.57,7.57,0,0,0,79.17,451.47Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "63.335px 446.03px"
    },
    id: "eldhwsyjpegzh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.7,
    y: 63.65,
    width: 93.63,
    height: 135.71,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "411.515px 131.505px"
    },
    id: "el4zwv4c5sdtf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.01,
    y: 63.65,
    width: 93.63,
    height: 135.71,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "406.825px 131.505px"
    },
    id: "eliwlpg9t19x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.65,
    y: 78.35,
    width: 70.36,
    height: 106.31,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "406.83px 131.505px"
    },
    id: "eldhfnywss5t7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,184.66s0-.18,0-.52,0-.85,0-1.51c0-1.34,0-3.29,0-5.83,0-5.1,0-12.52-.06-21.9,0-18.75-.07-45.29-.12-76.55l.24.23-70.36,0h0l.25-.25c0,40.1,0,77.08,0,106.31l-.2-.2,51.21.1,14.15.05,3.71,0c.84,0,1.29,0,1.29,0l-1.24,0-3.68,0-14.1.05-51.34.11h-.21v-.2c0-29.23,0-66.21-.05-106.31v-.26h.26l70.36,0h.23v.24c-.05,31.32-.09,57.92-.11,76.7,0,9.36-.05,16.77-.07,21.85,0,2.52,0,4.46,0,5.78,0,.65,0,1.14,0,1.49S442,184.66,442,184.66Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "406.915px 131.365px"
    },
    id: "elgcviif2qmjw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.9,63.65a15.59,15.59,0,0,1-1.67,2.42c-1.08,1.46-2.63,3.44-4.39,5.57s-3.41,4-4.63,5.38a16.27,16.27,0,0,1-2.06,2.11,18,18,0,0,1,1.79-2.34l4.51-5.47,4.5-5.47A17.26,17.26,0,0,1,453.9,63.65Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "447.525px 71.39px"
    },
    id: "elsbs6tml0s9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.37,184.32a87.15,87.15,0,0,0,12.27,15.34",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "448.505px 191.99px"
    },
    id: "el0fngmksuv9vh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.64,199.66a13.27,13.27,0,0,1-2.14-1.94,66.57,66.57,0,0,1-4.63-5.22,69.23,69.23,0,0,1-4.08-5.67,13.7,13.7,0,0,1-1.42-2.51,19.48,19.48,0,0,1,1.72,2.31c1,1.45,2.49,3.43,4.18,5.55s3.31,4,4.49,5.29A20.41,20.41,0,0,1,454.64,199.66Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "448.505px 191.99px"
    },
    id: "el8wblm5u1z7g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,199.25l12.26-15.13",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "366.13px 191.685px"
    },
    id: "eliiughx36q1d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.26,184.12a90.29,90.29,0,0,1-5.93,7.72,93.93,93.93,0,0,1-6.33,7.41,93.9,93.9,0,0,1,5.93-7.73A94.8,94.8,0,0,1,372.26,184.12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "366.13px 191.685px"
    },
    id: "el9hbsxf3lual",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360,63.65a84.68,84.68,0,0,1,6,7.11,85.38,85.38,0,0,1,5.55,7.44,84.78,84.78,0,0,1-5.95-7.12A85.21,85.21,0,0,1,360,63.65Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "365.775px 70.925px"
    },
    id: "el6qbw0a2ayjt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.53,
    y: 99.93,
    width: 23.56,
    height: 66.89,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "408.31px 133.375px"
    },
    id: "el86szlc9ng8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.42 41.97 164.42 116.74 57.02 116.74 53.16 42.49 164.42 41.97",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "108.79px 79.355px"
    },
    id: "el69bb6y444yj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eluufdaxa6w1f"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.81,
    y: 25.84,
    width: 74.09,
    height: 107.4,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "106.855px 79.54px",
      transform: "rotate(-90deg)"
    },
    className: "animable",
    id: "ell9m4pkmoq5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.06,117.09H52.65V42H161.06Zm-107.4-1H160V43H53.66Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "106.855px 79.545px"
    },
    id: "elukd7vh4spvb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.79,
    y: 51.7,
    width: 84.13,
    height: 55.68,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "106.855px 79.54px"
    },
    id: "elpzw1k9qy95j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.92,51.7h-1.61l-4.62,0-17.34.07-60.56.12L65,51.7c0,17,0,35.86,0,55.67h0l-.26-.27,84.13.06-.21.21c0-16.95.08-30.84.11-40.52,0-4.83,0-8.61.05-11.2q0-1.92,0-2.94c0-.67,0-1,0-1s0,.32,0,1,0,1.65,0,2.91c0,2.58,0,6.34.05,11.15,0,9.71.06,23.65.11,40.65v.21h-.21l-84.13,0h-.27v-.26h0c0-19.81,0-38.66,0-55.67v-.25h.25l60.72.12,17.28.07,4.57,0h1.17Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "106.675px 79.54px"
    },
    id: "el7x3970o3rjv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.15,42.28A9.09,9.09,0,0,1,55,43.48c1.1.79,2.6,1.92,4.21,3.21s3,2.52,4,3.43a8.94,8.94,0,0,1,1.54,1.58c-.1.11-2.69-2-5.91-4.6A59.2,59.2,0,0,1,53.15,42.28Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "58.95px 46.9921px"
    },
    id: "el5n13pgqlcph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.55,42.49a51.44,51.44,0,0,1-5.65,4.81,53.5,53.5,0,0,1-6,4.4,52.12,52.12,0,0,1,5.65-4.82A52.58,52.58,0,0,1,160.55,42.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "154.725px 47.095px"
    },
    id: "elst1u9c6rfsk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.47,116.6l-12-9.71",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "154.47px 111.745px"
    },
    id: "elay3ym3ohp77",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.49,106.89a57.5,57.5,0,0,1,6.16,4.65,56.38,56.38,0,0,1,5.82,5.06,56.36,56.36,0,0,1-6.16-4.65A57.84,57.84,0,0,1,148.49,106.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "154.48px 111.745px"
    },
    id: "elf94ov4veql6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.15,116.58a53.09,53.09,0,0,1,5.6-4.76,50.7,50.7,0,0,1,5.92-4.34,51,51,0,0,1-5.59,4.76A49.35,49.35,0,0,1,53.15,116.58Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "58.91px 112.03px"
    },
    id: "elkk1lhffi9j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzbj4u61tqxd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.02,
    y: 51.9,
    width: 18.64,
    height: 52.94,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "108.34px 78.37px",
      transform: "rotate(-90deg)"
    },
    className: "animable",
    id: "el0fjadgkpbv0r"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.85,93.88a29.38,29.38,0,0,0,3.7-14.31A29,29,0,0,0,249.71,50.4,28.52,28.52,0,0,0,242,51.45a29.27,29.27,0,0,1,0,56.25,28.56,28.56,0,0,0,23-3.38l13.56,5.24Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "260.28px 79.98px"
    },
    id: "el4kqr9ji5hld",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2",
    className: "animable",
    style: {
      transformOrigin: "250px 469.075px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.37,469.08c0,.14-95.09.26-212.36.26s-212.38-.12-212.38-.26,95.07-.27,212.38-.27S462.37,468.93,462.37,469.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250px 469.075px"
    },
    id: "elzu8md4gb0hb",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-2",
    className: "animable",
    style: {
      transformOrigin: "247.354px 281.353px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.09,437l.81,24.88,6.32,19.5a2.55,2.55,0,0,1-1.8,3.26h0a2.54,2.54,0,0,1-2.28-.53c-4-3.43-18.63-16.11-18.59-17.93,0-2.12-2.61-26.2-2.61-26.2Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "146.642px 460.86px"
    },
    id: "elb880z7dufb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.42,484.61l-21-20.14.06,1a3.84,3.84,0,0,0,1.05,2.44c1.68,1.76,6.43,6.54,17.51,16.12a2.54,2.54,0,0,0,2.35.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "146.92px 474.562px"
    },
    id: "el4szwl8t8xcp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.11,456.16a1.54,1.54,0,0,1,.53,2,1.47,1.47,0,0,1-2,.55,1.62,1.62,0,0,1-.56-2.11,1.54,1.54,0,0,1,2.11-.34",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "140.355px 457.443px"
    },
    id: "el4ubua7pqxgf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.13,474.07c.14.06.63-1.28,2.07-2.06a7.85,7.85,0,0,1,2.83-.71c0-.06-.3-.23-.89-.28a3.94,3.94,0,0,0-2.21.51,4,4,0,0,0-1.58,1.62C151.08,473.68,151.07,474.05,151.13,474.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "153.565px 472.542px"
    },
    id: "elh731881230d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.09,477.3a18.67,18.67,0,0,1,2.14-1.2,19.88,19.88,0,0,1,2.41-.44,2.79,2.79,0,0,0-2.6-.07C153.6,476.1,153,477.24,153.09,477.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "155.361px 476.301px"
    },
    id: "elm3ry5v34rag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.59,470a26.84,26.84,0,0,1,3.19-2.06,25.62,25.62,0,0,1,3.64-1.07,7,7,0,0,0-6.83,3.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.005px 468.402px"
    },
    id: "elpt7vq8pf63",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.71,462.44c.08.14,1.42-.51,3.2-.67s3.23.18,3.27,0a4.92,4.92,0,0,0-3.32-.58A5,5,0,0,0,146.71,462.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "149.945px 461.787px"
    },
    id: "elqjb5x5t10kp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.29,455.14a12.5,12.5,0,0,1,3.31-.79,12.15,12.15,0,0,1,3.34.65c0-.06-.25-.35-.84-.65a5.44,5.44,0,0,0-2.51-.54,5.53,5.53,0,0,0-2.49.64C146.53,454.78,146.25,455.09,146.29,455.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "149.613px 454.474px"
    },
    id: "el6hluaqxnc08",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.48,453a2.19,2.19,0,0,0,0-1,6.66,6.66,0,0,0-.88-2.42,3,3,0,0,0-1.32-1.31,1,1,0,0,0-1.14.29,1.62,1.62,0,0,0-.33,1.15,3.6,3.6,0,0,0,3.34,3.15,4.18,4.18,0,0,0,4-2.41,1.46,1.46,0,0,0,0-1.21,1,1,0,0,0-1.08-.47,3.53,3.53,0,0,0-1.59.94,7.24,7.24,0,0,0-1.59,2,2.2,2.2,0,0,0-.33.88,11.73,11.73,0,0,1,2.17-2.61,3.41,3.41,0,0,1,1.41-.79.54.54,0,0,1,.59.26,1,1,0,0,1-.05.79,3.75,3.75,0,0,1-3.48,2.06,3.14,3.14,0,0,1-2.87-2.64,1.17,1.17,0,0,1,.2-.81.54.54,0,0,1,.62-.17,2.61,2.61,0,0,1,1.14,1.09A9.71,9.71,0,0,1,149.48,453Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "149.542px 450.599px"
    },
    id: "eln3z55z6qqhi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.53,440.66l-1.29,18.61s18.49,7.56,18.58,11l-36.17-1.2.82-29.08Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "199.735px 455.13px"
    },
    id: "eld6nkl1zgvo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.11,457.33A1.49,1.49,0,0,0,187,459a1.43,1.43,0,0,0,1.63,1.09,1.56,1.56,0,0,0,1.13-1.76,1.47,1.47,0,0,0-1.81-.94",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "188.382px 458.72px"
    },
    id: "el92os9vncrz9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.65,469.09l.2-2.93,34.61,2.25s1.58.76,1.36,1.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "199.745px 468.225px"
    },
    id: "elkcj59ugy5oq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.84,459.11c0,.17-.9.22-1.79.76s-1.37,1.27-1.53,1.19.13-1.08,1.22-1.72S199.88,459,199.84,459.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "198.16px 460.005px"
    },
    id: "el1g3abayy94j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.58,460.8c0,.17-.74.45-1.37,1.18s-.82,1.51-1,1.49-.25-1,.54-1.9S203.58,460.63,203.58,460.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "202.337px 462.096px"
    },
    id: "el0ws7durekcn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.58,465.41c-.16,0-.38-.85.11-1.81s1.32-1.31,1.39-1.16-.45.65-.84,1.44S205.76,465.4,205.58,465.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "206.238px 463.908px"
    },
    id: "elq9eqqefjdbs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.66,454.83c-.08.16-.88-.11-1.88-.07s-1.79.32-1.88.16.68-.76,1.86-.78S199.75,454.7,199.66,454.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "197.78px 454.554px"
    },
    id: "elmtxn2h91y4f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.85,451.07A3.29,3.29,0,0,1,198,451a7.89,7.89,0,0,1-1.88-.64,8.33,8.33,0,0,1-1-.59,2,2,0,0,1-.53-.44.76.76,0,0,1-.05-.94,1,1,0,0,1,.79-.38,2.53,2.53,0,0,1,.67.11,7,7,0,0,1,1.12.43,6.31,6.31,0,0,1,1.63,1.15c.81.81,1.08,1.47,1,1.51s-.48-.51-1.31-1.18a6.9,6.9,0,0,0-1.58-1,6.56,6.56,0,0,0-1-.35c-.38-.12-.71-.13-.81,0s-.05.09,0,.2a2,2,0,0,0,.39.33,10.72,10.72,0,0,0,.94.57,9.53,9.53,0,0,0,1.73.73A14.48,14.48,0,0,1,199.85,451.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "197.125px 449.611px"
    },
    id: "elvckmtlilser",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.61,451.32a3,3,0,0,1-.42-1.77,6.12,6.12,0,0,1,.81-3.06,1.49,1.49,0,0,1,1.19-.87.85.85,0,0,1,.74.53,2.31,2.31,0,0,1,.16.67,3.81,3.81,0,0,1,0,1.22,4.08,4.08,0,0,1-.83,1.84c-.74.92-1.48,1.11-1.5,1s.57-.41,1.15-1.29a4.27,4.27,0,0,0,.63-1.68,4.1,4.1,0,0,0,0-1.05c-.05-.39-.18-.7-.33-.67s-.49.27-.65.58a5.74,5.74,0,0,0-.48,1,6.38,6.38,0,0,0-.41,1.8C199.54,450.63,199.71,451.3,199.61,451.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "200.66px 448.47px"
    },
    id: "elit7rwfb2bdh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.17 257.02 131.51 457.06 160.05 456.21 166.85 250.2 126.17 257.02",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "146.51px 353.63px"
    },
    id: "el4d8qwe3rxy8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.48,249.86s21.18,84.8,21.83,99.26S202.78,454,202.78,454H174.84L177.18,351,156,263.94l5.13-13.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "181.683px 351.93px"
    },
    id: "el02sfsr4ev2uq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.24,260.27a1.23,1.23,0,0,1,0,.28l0,.79c0,.74-.06,1.75-.11,3.05-.12,2.68-.3,6.5-.51,11.2-.49,9.49-1.16,22.54-1.9,37s-1.52,27.45-2,36.94c-.28,4.7-.52,8.51-.68,11.2-.09,1.29-.16,2.31-.21,3,0,.32-.05.59-.07.79a1.14,1.14,0,0,1,0,.27,1.1,1.1,0,0,1,0-.27c0-.21,0-.47,0-.79,0-.74.07-1.76.12-3.05.12-2.68.3-6.5.51-11.2.49-9.49,1.16-22.54,1.89-37s1.52-27.45,2.05-36.94c.28-4.7.51-8.51.68-11.19.09-1.29.16-2.31.21-3.05,0-.32.05-.58.07-.79A.72.72,0,0,1,168.24,260.27Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "165.521px 312.53px"
    },
    id: "elzw7gfj54r3f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.1,141.12s10.37,51.44,10.52,65.93,5.24,42.81,5.24,42.81H136l-1-78.37-3.2-23.37,6.74-9.62Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "156.33px 194.18px"
    },
    id: "elkqilhmaib4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.65,142.63s10.71,3.15,13.54,7.11c2.23,3.13,5.25,62.29,5.25,62.29L189,264.15l-4.49-.42-6.34-19.51Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "177.325px 203.39px"
    },
    id: "elfn8pic5utze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.19,149.74l30.24,27.75,37.21-12.06,7.42,15.63-39.71,18c-5.67,2.42-9.23,1.09-13.17-2.07l-20.83-16.68Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "216.625px 175.023px"
    },
    id: "elbubqwka2x1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.72,170.41a.83.83,0,0,1-.34,1.11.81.81,0,0,1-1.1-.34.8.8,0,0,1,.33-1.1A.83.83,0,0,1,239.72,170.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "238.996px 170.8px"
    },
    id: "elr5l1cwm18dd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,171.64a.69.69,0,0,1-.25,0,.84.84,0,0,1-.5-.41.88.88,0,0,1-.06-.64.86.86,0,0,1,1.05-.56.85.85,0,0,1,.5.41.84.84,0,0,1,.06.64.82.82,0,0,1-.41.5A.78.78,0,0,1,239,171.64Zm0-1.63a.84.84,0,0,0-.37.09.81.81,0,0,0-.38.47.79.79,0,0,0,.06.6.79.79,0,0,0,1.07.32.76.76,0,0,0,.38-.46.81.81,0,0,0-.06-.61A.79.79,0,0,0,239,170Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "238.996px 170.825px"
    },
    id: "elql9uazfj1gq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.84,169.67a.83.83,0,0,1-.34,1.11.81.81,0,0,1-1.1-.34.8.8,0,0,1,.33-1.1A.81.81,0,0,1,242.84,169.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "242.116px 170.057px"
    },
    id: "eld0slvj6rcp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.12,170.9a.69.69,0,0,1-.25,0,.84.84,0,0,1-.5-.41.85.85,0,0,1,.35-1.14.85.85,0,0,1,1.14.35.84.84,0,0,1,.06.64.85.85,0,0,1-.41.5A.9.9,0,0,1,242.12,170.9Zm0-1.64a.86.86,0,0,0-.37.1.79.79,0,0,0-.32,1.07.75.75,0,0,0,.47.38.79.79,0,1,0,.45-1.51A.85.85,0,0,0,242.11,169.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "242.123px 170.083px"
    },
    id: "el1e5phzov7ah",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.8,169.07a.81.81,0,0,1-.33,1.11.83.83,0,0,1-1.11-.34.81.81,0,0,1,.34-1.1A.8.8,0,0,1,245.8,169.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "245.083px 169.456px"
    },
    id: "elcvm336vg33",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.09,170.3a.69.69,0,0,1-.25,0,.84.84,0,0,1-.56-1,.8.8,0,0,1,.41-.49.84.84,0,0,1,1.14.34h0a.85.85,0,0,1-.35,1.14A.9.9,0,0,1,245.09,170.3Zm0-1.63a.84.84,0,0,0-.37.09.79.79,0,0,0-.32,1.07.75.75,0,0,0,.46.38.81.81,0,0,0,.61-.06.79.79,0,0,0,.32-1.07h0A.79.79,0,0,0,245.08,168.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "245.091px 169.493px"
    },
    id: "ell2ozre5fb9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.01 166.21 249.89 165.16 256.5 179.08 253.69 180.28 247.01 166.21",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "251.755px 172.72px"
    },
    id: "elk3eho2ew919",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.16,160.71a9,9,0,0,1,.17,1.55c.11,1.1.26,2.52.44,4.24.41,3.67,1,8.56,1.58,14s1.09,10.41,1.31,14c.12,1.8.17,3.26.18,4.27a7.57,7.57,0,0,1-.05,1.56,9.18,9.18,0,0,1-.15-1.55c-.07-1-.18-2.46-.35-4.25-.32-3.58-.85-8.53-1.46-14s-1.13-10.4-1.43-14c-.15-1.8-.23-3.26-.27-4.27A7.84,7.84,0,0,1,180.16,160.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "181.982px 180.52px"
    },
    id: "elygqy0u9u17h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.77,167.65a58.16,58.16,0,0,1-1.9,7.46,58.65,58.65,0,0,1-2.39,7.31,57,57,0,0,1,1.89-7.46A57,57,0,0,1,186.77,167.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "184.625px 175.035px"
    },
    id: "el2fl1b3206cc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.11,186.86a3.16,3.16,0,0,1-.67-1.32,9.57,9.57,0,0,1,.44-7,3.33,3.33,0,0,1,.83-1.23,18.77,18.77,0,0,0-1.2,4.74A18.65,18.65,0,0,0,209.11,186.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "208.843px 182.085px"
    },
    id: "elood67i11g69",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.65 219.01 209.52 219.31 207.99 235.45 204.25 235.03 205.65 219.01",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "206.885px 227.23px"
    },
    id: "elacho2np3leg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.54,139.62l-20.87,13.31a13.54,13.54,0,0,0-5,15.37l16,50.29-5.77,45.7,45.74-1.94-1.12-20-3.88-35.84a71,71,0,0,0-4.91-19.34Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "140.3px 201.955px"
    },
    id: "elrsedxukui2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.74,171.05l20.87,43.68a12.92,12.92,0,0,0,8.68,7l57.92,13.72,1.48-16.86L161.48,202l-22.24-42.68a12.7,12.7,0,0,0-17.82-5h0A12.69,12.69,0,0,0,116.74,171.05Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "160.495px 193.972px"
    },
    id: "elh30zztxufd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.69,218.59a.78.78,0,0,1-.24-.06l-.68-.23-2.62-.94-9.7-3.57-32.69-12.22-.09,0,0-.1-3.85-7.62c-3.62-7.06-7.23-13.71-10.61-19.71-1.69-3-3.32-5.83-4.86-8.47l-2.24-3.82c-.36-.62-.72-1.21-1.1-1.76a14.76,14.76,0,0,0-1.18-1.58,13.9,13.9,0,0,0-5.56-4,12.55,12.55,0,0,0-5.13-.92,9.09,9.09,0,0,0-4.3,1.15,1.19,1.19,0,0,1,.24-.17,4.39,4.39,0,0,1,.77-.43,9.16,9.16,0,0,1,3.28-.75,12.7,12.7,0,0,1,5.24.84,14.22,14.22,0,0,1,5.74,4.07,15,15,0,0,1,1.22,1.6c.4.57.77,1.16,1.12,1.78l2.27,3.8q2.34,4,4.91,8.46c3.4,6,7,12.63,10.66,19.7,1.33,2.61,2.63,5.18,3.84,7.64l-.14-.13,32.63,12.38,9.64,3.71,2.59,1,.67.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "163.265px 185.982px"
    },
    id: "elkj29qt5ustp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.85,229.1a.82.82,0,0,1-1.64,0,.82.82,0,0,1,1.64,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "195.03px 229.1px"
    },
    id: "elis5x95cgt4s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,229.94a.84.84,0,1,1,.84-.84A.84.84,0,0,1,195,229.94Zm0-1.63a.79.79,0,1,0,.79.79A.79.79,0,0,0,195,228.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "195px 229.1px"
    },
    id: "elgwxfrtvu266",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,229.92a.82.82,0,1,1-.82-.82A.82.82,0,0,1,199,229.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "198.18px 229.92px"
    },
    id: "el5k94hitpas",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.13,230.76a.84.84,0,1,1,.84-.84A.85.85,0,0,1,198.13,230.76Zm0-1.63a.79.79,0,1,0,.79.79A.79.79,0,0,0,198.13,229.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "198.13px 229.92px"
    },
    id: "el0b1d09wzrf1b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.03,
    cy: 230.79,
    r: 0.82,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "201.03px 230.79px"
    },
    id: "el0wjxm20bg83g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,231.63a.84.84,0,1,1,.84-.84A.85.85,0,0,1,201,231.63Zm0-1.63a.79.79,0,1,0,.79.79A.79.79,0,0,0,201,230Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "201px 230.79px"
    },
    id: "elrx8h4sveix",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.21,235.45a.87.87,0,0,1-.28,0l-.81-.18-3.12-.75-11.46-2.82c-9.67-2.37-23-5.73-37.82-9.16-1.85-.44-3.68-.79-5.49-1.28a12.23,12.23,0,0,1-4.95-2.47,14.51,14.51,0,0,1-3-4.4l-2.18-4.56L127.57,194l-5-10.68c-.56-1.24-1-2.21-1.33-2.91l-.34-.77a1.42,1.42,0,0,1-.1-.26s.06.08.15.24.22.44.38.74l1.43,2.88c1.23,2.54,3,6.15,5.16,10.6s4.73,9.84,7.59,15.77c.71,1.48,1.45,3,2.19,4.55a14.37,14.37,0,0,0,2.93,4.24,11.66,11.66,0,0,0,4.75,2.35c1.77.48,3.62.83,5.47,1.27,14.81,3.44,28.14,6.85,37.79,9.31,4.79,1.26,8.68,2.27,11.42,3l3.09.85.8.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.505px 207.421px"
    },
    id: "elmz59qom1bz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.43,232.72s-.22.23-.69.58-1.14.83-2,1.41a32.52,32.52,0,0,1-7.2,3.74,16.57,16.57,0,0,1-8.06.81,10.92,10.92,0,0,1-2.38-.69,2.4,2.4,0,0,1-.79-.43,26.09,26.09,0,0,0,3.22.75,17.49,17.49,0,0,0,7.84-.93,39.09,39.09,0,0,0,7.17-3.56A24.21,24.21,0,0,1,157.43,232.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "146.87px 236.079px"
    },
    id: "el7wwfpykjcxk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,238.52a1.47,1.47,0,0,1,.14.37,9.3,9.3,0,0,1,.27,1.12,12.58,12.58,0,0,1,0,4.25,13.09,13.09,0,0,1-2.6,5.72,12.83,12.83,0,0,1-14.12,4,13,13,0,0,1-5.19-3.55,12.54,12.54,0,0,1-2.24-3.61,10.55,10.55,0,0,1-.35-1.1c-.06-.25-.09-.39-.07-.39a15.2,15.2,0,0,0,2.93,4.85,12.9,12.9,0,0,0,5.08,3.34,12.5,12.5,0,0,0,13.58-3.79,12.9,12.9,0,0,0,2.61-5.49A15.22,15.22,0,0,0,160,238.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "148.212px 246.602px"
    },
    id: "elr4p5xurmki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.79,99.81l.13,37.26a11.08,11.08,0,0,0,11.67,11h0A11.1,11.1,0,0,0,163.09,137c0-2.81,0-5.15,0-5.44,0,0,9.48-.92,10.13-10.31.32-4.54.2-13.94,0-22.45A17.52,17.52,0,0,0,156.69,81.7l-.91,0C146,81.66,140.5,90,140.79,99.81Z",
    style: {
      fill: "rgb(183, 136, 118)",
      transformOrigin: "157.098px 114.893px"
    },
    id: "el76qe5n3v3wp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.11,131.41a21.91,21.91,0,0,1-12.05-4.18s2.51,6.93,11.93,6.61Z",
    style: {
      fill: "rgb(170, 101, 80)",
      transformOrigin: "157.085px 130.54px"
    },
    id: "elbvdz2112ydj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.9,104.31a1.35,1.35,0,0,1-1.38,1.28,1.28,1.28,0,0,1-1.31-1.29,1.35,1.35,0,0,1,1.37-1.28A1.29,1.29,0,0,1,170.9,104.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.555px 104.305px"
    },
    id: "elscwo856flik",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.16,102.72c-.17.17-1.15-.64-2.59-.72s-2.55.58-2.69.4.11-.39.59-.7a3.74,3.74,0,0,1,2.17-.54,3.5,3.5,0,0,1,2.05.8C171.12,102.32,171.25,102.65,171.16,102.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "168.514px 101.948px"
    },
    id: "el3vvrrwrgpjf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.86,104.2a1.34,1.34,0,0,1-1.37,1.28,1.28,1.28,0,0,1-1.31-1.29,1.34,1.34,0,0,1,1.37-1.28A1.28,1.28,0,0,1,156.86,104.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "155.52px 104.195px"
    },
    id: "elwk2fvx38me",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.79,102.4c-.18.16-1.15-.65-2.6-.73s-2.54.59-2.69.4.12-.39.6-.7a3.62,3.62,0,0,1,2.16-.53,3.56,3.56,0,0,1,2.06.79C156.74,102,156.87,102.32,156.79,102.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "154.135px 101.626px"
    },
    id: "elk52fji48e2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.36,113.75a9.6,9.6,0,0,1,2.37-.29c.37,0,.73-.07.8-.32a1.89,1.89,0,0,0-.18-1.1c-.3-.92-.61-1.87-.93-2.88-1.29-4.08-2.2-7.43-2-7.48s1.34,3.22,2.63,7.3c.3,1,.6,2,.88,2.89a2.11,2.11,0,0,1,.11,1.46.93.93,0,0,1-.64.5,2.41,2.41,0,0,1-.63,0A9.37,9.37,0,0,1,161.36,113.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "163.241px 107.776px"
    },
    id: "el1jrv05hi36q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.37,99.4c-.17.39-1.6.12-3.3.23s-3.11.49-3.31.12c-.09-.17.17-.53.74-.88a5.45,5.45,0,0,1,2.49-.71,5.53,5.53,0,0,1,2.55.45C157.15,98.89,157.44,99.22,157.37,99.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "154.061px 99.0289px"
    },
    id: "el3shfmkl6blv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,99.28c-.27.31-1.25-.09-2.44-.17s-2.22.09-2.44-.26c-.09-.17.09-.49.55-.78a3.56,3.56,0,0,1,3.93.35C171,98.78,171.16,99.12,171,99.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "168.579px 98.5164px"
    },
    id: "el21yfq8r63cx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.16,106.81c-.16-.08-6.35-2.28-6.51,4.16s6.33,5.27,6.35,5.09S141.16,106.81,141.16,106.81Z",
    style: {
      fill: "rgb(183, 136, 118)",
      transformOrigin: "137.904px 111.321px"
    },
    id: "el623a8mpd6de",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.09,113.57s-.11.07-.3.16a1.1,1.1,0,0,1-.84,0,2.77,2.77,0,0,1-1.22-2.52,3.72,3.72,0,0,1,.35-1.6,1.32,1.32,0,0,1,.87-.84.56.56,0,0,1,.65.33c.08.18,0,.31.07.32s.14-.11.1-.37a.76.76,0,0,0-.25-.41.83.83,0,0,0-.61-.18,1.58,1.58,0,0,0-1.2,1,3.78,3.78,0,0,0-.43,1.78,2.9,2.9,0,0,0,1.57,2.82,1.23,1.23,0,0,0,1-.14C139.08,113.72,139.12,113.58,139.09,113.57Z",
    style: {
      fill: "rgb(170, 101, 80)",
      transformOrigin: "137.684px 111.282px"
    },
    id: "elctp0yzp7he",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.6,106.39a3.39,3.39,0,0,1,3,1.76c.36.94.4,2,.76,2.93a2.28,2.28,0,0,0,2.25,1.65,2,2,0,0,0,1.43-1.39,5.54,5.54,0,0,0,.13-2.07c-.2-3-.67-6-.61-9.07A15.46,15.46,0,0,1,147,91.58a8.46,8.46,0,0,1,7.76-3.8c2,.28,3.76,1.42,5.72,1.81a7.88,7.88,0,0,0,6.65-1.8,2.27,2.27,0,0,1,.32-.23,1.73,1.73,0,0,0,.73-2,1.7,1.7,0,0,0-.34-.64c-3.73-3.86-10.77-5.28-16-4.27a18.81,18.81,0,0,0-12.87,9.15c-2.51,4.75-2.24,11.56-1.28,16.56",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "152.632px 96.533px"
    },
    id: "el4u4z08y8mwp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,114.88c.24,0,.24,1.55,1.58,2.66s3,.94,3,1.16-.37.31-1.08.32a3.85,3.85,0,0,1-2.52-.87,3.4,3.4,0,0,1-1.22-2.23C157.67,115.26,157.85,114.87,158,114.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "160.158px 116.95px"
    },
    id: "elqfeog9m1wr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.81,167.8s7.05-6.19,8.38-6.65,11.95-.65,12.66-.12,11.46,6.42,9.68,7.33S269.3,165,269.3,165l-1.25.17s6.5,3.47,7.65,4.8.05,2.71-1.16,2.14-6.79-3.78-7.23-3.66,5.94,3.85,6.53,4.55c.79.92.28,2.72-.95,2.2-.72-.3-6.6-4.2-6.6-4.2a58.83,58.83,0,0,1,4.76,4.35c.52,1-.48,1.91-1.51,1.28-.7-.43-3.73-3.41-4.67-4,0,0-1-.08-2.57,1.56s-7.58,3.87-7.58,3.87Z",
    style: {
      fill: "rgb(183, 136, 118)",
      transformOrigin: "263.269px 169.385px"
    },
    id: "ellhgl6v0crm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.5,168.38a5.66,5.66,0,0,1-2.28-.14,13.28,13.28,0,0,1-2.39-.72c-.83-.4-1.74-.86-2.7-1.35l-2-1,.14,0a34.28,34.28,0,0,1-5.46-.15,31.61,31.61,0,0,1,5.45-.39h.06l.07,0,2,1L274,167a15.69,15.69,0,0,0,2.27.8C277.64,168.2,278.51,168.29,278.5,168.38Z",
    style: {
      fill: "rgb(170, 101, 80)",
      transformOrigin: "271.155px 166.532px"
    },
    id: "ellcdihwo4i6g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.43,169.59a2.39,2.39,0,0,0,2.65.91c1-.21,1.87-.74,2.83-1,2.89-.83,6.1.71,8.94-.26.4-.14.84-.43.8-.84s-.48-.58-.85-.7l-9.48-3",
    style: {
      fill: "rgb(183, 136, 118)",
      transformOrigin: "258.041px 167.652px"
    },
    id: "el2y7pvmhj3zy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.32,164.66a3.73,3.73,0,0,1,1.06.22c.67.18,1.63.46,2.82.81l4.16,1.26,1.2.37c.38.15.93.18,1.29.77a.83.83,0,0,1-.15.92,1.72,1.72,0,0,1-.68.45,6.39,6.39,0,0,1-1.44.32,38.45,38.45,0,0,1-5.35-.29,7.62,7.62,0,0,0-2.23.21c-.67.18-1.29.48-1.88.69a3.5,3.5,0,0,1-3,0c-.64-.37-.74-.83-.72-.82a3,3,0,0,0,.82.63A3.41,3.41,0,0,0,254,170a20.15,20.15,0,0,1,1.9-.77,7.66,7.66,0,0,1,2.38-.28,44.76,44.76,0,0,0,5.27.25,6.56,6.56,0,0,0,1.29-.29c.39-.14.66-.42.54-.6s-.54-.37-1-.49l-1.2-.39-4.12-1.38c-1.17-.4-2.12-.73-2.77-1A3.8,3.8,0,0,1,255.32,164.66Z",
    style: {
      fill: "rgb(170, 101, 80)",
      transformOrigin: "258.162px 167.694px"
    },
    id: "el7b98r3x4pmi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.78,219.4l11.69-1.16s15.46,10.59,14,12.92-4,0-4,0,2.75,3.39-1.7,4.45c0,0-1.06,2.33-2.75,2.12h-1.06s-1,2.95-2.39,2.31-5.74-4.44-5.74-4.44l-12-1.06Z",
    style: {
      fill: "rgb(183, 136, 118)",
      transformOrigin: "218.699px 229.185px"
    },
    id: "elb1vyafktel",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.05,231.45s-3,1.15-3.61,2.36-1,4,.94,4.55a17.72,17.72,0,0,0,3.41-.11l-.74-3.15a22.29,22.29,0,0,1,1.78-1.84C217.47,232.73,216.77,230.66,215.05,231.45Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "214.003px 234.834px"
    },
    id: "elxi9zkdx3u1h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.42,233.05s-3,1.15-3.61,2.35a2.64,2.64,0,0,0,1.72,3.74,13.86,13.86,0,0,0,3.09-.1l-.32-.61c-.6-1.18-.86-2.14.2-2.93.06,0,.66-.6.7-.64A1.31,1.31,0,0,0,218.42,233.05Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "217.46px 236.028px"
    },
    id: "elwv24yvnm7j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.14,238.93a1.76,1.76,0,0,1-.24-2.06,2.85,2.85,0,0,1,1.76-1.28,1.31,1.31,0,0,1,1.37.22,1.18,1.18,0,0,1,.19.9A4.75,4.75,0,0,1,221,238.9c-.28.35-.62.73-1.07.72s-.78-.43-1-.81",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "220.457px 237.554px"
    },
    id: "elagb2pxffdo8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.96 144.67 158.59 143.68 160.86 147.75 159.59 152.1 156.91 152.76 154.24 149.39 155.96 144.67",
    style: {
      fill: "#68A1D6",
      transformOrigin: "157.55px 148.22px"
    },
    id: "elxo1tcjfrz6r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.91,152.76s3.41,18.71,6.24,31.87c0,0,2.33,11,3.27,13.48,1.05,2.83,4.29,7,4.29,7l3.29,1.28-2-18.49L159.6,152.1Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "165.455px 179.245px"
    },
    id: "elhtvj0pstk08",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elk8zz0tbm8yo"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "157.55px 148.22px"
    },
    className: "animable",
    id: "el2vwql5utpi8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "155.96 144.67 158.59 143.68 160.86 147.75 159.59 152.1 156.91 152.76 154.24 149.39 155.96 144.67",
    id: "el554lz24crck",
    className: "animable",
    style: {
      transformOrigin: "157.55px 148.22px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elqxl3orn1uy"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      transformOrigin: "165.455px 179.245px"
    },
    className: "animable",
    id: "elvm3f6g3dn5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.91,152.76s3.41,18.71,6.24,31.87c0,0,2.67,10.86,3.27,13.48.35,1.55,4.29,7,4.29,7l3.29,1.28-2-18.49L159.6,152.1Z",
    id: "el5xsjug8ancr",
    className: "animable",
    style: {
      transformOrigin: "165.455px 179.245px"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "140.18 133.3 155.96 144.67 152.55 154.05 138.19 139.27 140.18 133.3",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "147.075px 143.675px"
    },
    id: "el54njni8lkz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.59 143.68 162.99 133.84 165.49 141.96 162.02 150.48 158.59 143.68",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "162.04px 142.16px"
    },
    id: "eldpeci1zazy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,144.67a3,3,0,0,1-.18.72l-.64,2c-.56,1.67-1.38,4-2.37,6.78l-.13.38-.28-.3-3.67-4.06c-2.86-3.17-5.43-6.06-7.26-8.17l-2.16-2.52a5.71,5.71,0,0,1-.74-1,6,6,0,0,1,.89.84l2.28,2.4c1.91,2,4.52,4.9,7.37,8.07,1.29,1.44,2.52,2.82,3.66,4.08l-.41.08c1-2.74,1.9-5.07,2.54-6.72l.77-1.91A2.62,2.62,0,0,1,156,144.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "147.285px 146.525px"
    },
    id: "el2mgn5a5063q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.49,142a11.85,11.85,0,0,1-.74,2.3c-.51,1.39-1.26,3.31-2.12,5.41l-.37.91-.26.63-.22-.64a43.5,43.5,0,0,0-3.15-6.46,6.52,6.52,0,0,1,1.32,1.64,21.73,21.73,0,0,1,2.32,4.65h-.49c.12-.3.25-.6.37-.91.86-2.11,1.66-4,2.26-5.36A10.43,10.43,0,0,1,165.49,142Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.06px 146.625px"
    },
    id: "ellkqyj0ojxr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,438.07l6.08,24.14,10.32,17.71a2.55,2.55,0,0,1-1.07,3.57h0a2.52,2.52,0,0,1-2.33,0c-4.64-2.5-21.64-11.79-22-13.58-.4-2.07-8.11-25-8.11-25Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "365.819px 460.923px"
    },
    id: "elbiwg413x1ju",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elgj3r10tvrsq"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "368.99px 475.99px"
    },
    className: "animable",
    id: "el6x2zg1sxqa6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.37,483.49l-24.76-15.23.28,1a3.84,3.84,0,0,0,1.54,2.16c2,1.37,7.68,5,20.53,12a2.57,2.57,0,0,0,2.41,0Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "368.99px 475.99px"
    },
    id: "elvfkmndhlmid",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eli5jij8x15f"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "358.932px 460.547px"
    },
    className: "animable",
    id: "elpb3hgamcu07"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.39,459.16a1.54,1.54,0,0,1,.95,1.83,1.48,1.48,0,0,1-1.81.95,1.62,1.62,0,0,1-1-1.94,1.53,1.53,0,0,1,2-.78",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "358.932px 460.547px"
    },
    id: "elb33yei91oj8",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M373,474.52a7.71,7.71,0,0,1,1.58-2.45,8,8,0,0,1,2.62-1.29c0-.06-.35-.16-.93-.09a4.1,4.1,0,0,0-3.26,2.89C372.86,474.16,372.92,474.52,373,474.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "375.059px 472.593px"
    },
    id: "elooch73bx2m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.58,477.26c.15.08.7-.92,1.84-1.62a22.87,22.87,0,0,1,2.26-.95,2.83,2.83,0,0,0-2.55.49C375.84,476,375.44,477.23,375.58,477.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "377.617px 475.919px"
    },
    id: "elnubba16bq1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.67,471.28a13.06,13.06,0,0,1,6-4.5,7,7,0,0,0-6,4.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "371.67px 469.03px"
    },
    id: "elb1c89c7am",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.2,464.1c.11.12,1.28-.8,3-1.33s3.19-.51,3.2-.67a4.89,4.89,0,0,0-3.37.14A5,5,0,0,0,366.2,464.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "369.3px 462.988px"
    },
    id: "elkosy6xruml",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.24,457.06a12,12,0,0,1,3.07-1.47,12.46,12.46,0,0,1,3.4-.09c0-.06-.32-.28-1-.45a5.52,5.52,0,0,0-2.57,0,5.45,5.45,0,0,0-2.29,1.16C364.39,456.65,364.19,457,364.24,457.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "367.471px 455.979px"
    },
    id: "elp95umvfrl3r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.89,454.26a2.13,2.13,0,0,0-.21-.92,6.59,6.59,0,0,0-1.38-2.18,2.94,2.94,0,0,0-1.57-1,1,1,0,0,0-1.05.53,1.61,1.61,0,0,0-.08,1.18,3.6,3.6,0,0,0,3.93,2.38,4.2,4.2,0,0,0,3.38-3.21,1.47,1.47,0,0,0-.26-1.18,1,1,0,0,0-1.15-.23,3.56,3.56,0,0,0-1.36,1.26,7.25,7.25,0,0,0-1.12,2.32,2.25,2.25,0,0,0-.14.93,11.54,11.54,0,0,1,1.57-3,3.36,3.36,0,0,1,1.21-1.07.54.54,0,0,1,.63.13,1,1,0,0,1,.12.78,3.74,3.74,0,0,1-3,2.75,3.13,3.13,0,0,1-3.37-2,1.23,1.23,0,0,1,0-.83.55.55,0,0,1,.58-.3,2.65,2.65,0,0,1,1.34.82A9.63,9.63,0,0,1,366.89,454.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "366.233px 451.914px"
    },
    id: "el2tpmpsfoyik",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.63,442.57l1.29,18.61s-18.48,7.56-18.58,11L309.51,471l-.81-29.08Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "291.425px 457.05px"
    },
    id: "elyolx6uxl6qp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.05,459.24a1.48,1.48,0,0,1,1.08,1.66A1.43,1.43,0,0,1,302.5,462a1.56,1.56,0,0,1-1.13-1.76,1.48,1.48,0,0,1,1.82-.94",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "302.749px 460.629px"
    },
    id: "elv5tw26gy45",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.51,471l-.19-2.93-34.61,2.25s-1.59.76-1.37,1.89Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "291.415px 470.14px"
    },
    id: "elwoafkh7aw5e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.33,461c0,.17.9.23,1.78.76s1.38,1.27,1.54,1.2-.14-1.09-1.22-1.73S291.29,460.86,291.33,461Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "293.01px 461.893px"
    },
    id: "eld18qsdatg19",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.59,462.71c0,.18.74.45,1.36,1.18s.83,1.51,1,1.5.26-1-.54-1.91S287.59,462.55,287.59,462.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "288.827px 464.012px"
    },
    id: "ele4z2y12secd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.58,467.33c.17,0,.38-.86-.1-1.81s-1.33-1.31-1.4-1.16.46.65.85,1.43S285.41,467.31,285.58,467.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "284.925px 465.829px"
    },
    id: "elm6hbhpcjc9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.51,456.75c.08.15.88-.12,1.88-.08s1.79.32,1.87.17-.68-.76-1.86-.79S291.41,456.61,291.51,456.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "293.384px 456.466px"
    },
    id: "el53lny5w9q46",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.32,453a3.55,3.55,0,0,0,1.81-.07,8.21,8.21,0,0,0,1.87-.65,7.65,7.65,0,0,0,1-.59,2,2,0,0,0,.54-.44.77.77,0,0,0,.05-.94,1,1,0,0,0-.79-.38,2.24,2.24,0,0,0-.68.12,6.08,6.08,0,0,0-1.11.42,6.31,6.31,0,0,0-1.63,1.15c-.82.81-1.08,1.48-1,1.51s.47-.51,1.3-1.18a7.35,7.35,0,0,1,1.59-1,6.23,6.23,0,0,1,1-.35c.38-.11.7-.13.81,0s0,.09,0,.2a1.76,1.76,0,0,1-.4.33,9.56,9.56,0,0,1-.94.58,11.13,11.13,0,0,1-1.72.73A10.88,10.88,0,0,0,291.32,453Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "294.023px 451.531px"
    },
    id: "el6ocu94wgj7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.55,453.23c.07,0,.4-.62.42-1.76a6,6,0,0,0-.31-2,5.51,5.51,0,0,0-.5-1.08,1.51,1.51,0,0,0-1.18-.88.85.85,0,0,0-.74.53,2.36,2.36,0,0,0-.17.67,4.1,4.1,0,0,0,0,1.22,4.18,4.18,0,0,0,.84,1.85c.74.91,1.48,1.1,1.49,1s-.57-.41-1.14-1.3a4.12,4.12,0,0,1-.63-1.68,3.69,3.69,0,0,1,0-1.05c0-.38.18-.7.32-.66s.5.27.66.57a7.16,7.16,0,0,1,.48,1,6.38,6.38,0,0,1,.41,1.8C291.62,452.54,291.46,453.21,291.55,453.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "290.498px 450.37px"
    },
    id: "elv4a2iftui3o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.76 240.14 286.58 456.7 315.12 455.84 312.92 269.98 349.28 461.01 375.05 454.28 341.78 240.56 280.76 240.14",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "327.905px 350.575px"
    },
    id: "el5ztwnl1z697",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.4,457c-.15,0-.26-44.89-.26-100.26s.11-100.26.26-100.26.26,44.88.26,100.26S296.54,457,296.4,457Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "296.4px 356.74px"
    },
    id: "eljtnm9mntylc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.42,460.94c-.14,0-6.8-43-14.88-96.11S328,268.64,328.17,268.62s6.8,43,14.88,96.13S357.57,460.92,357.42,460.94Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "342.795px 364.78px"
    },
    id: "elah54v4inwdc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.65,104.72a43.63,43.63,0,0,0,2.41-6.89c.34-1.8.88-4.49.16-6.17s-2.47-3.3-4.67-2.84a10.47,10.47,0,0,0-6.05-8.19,26.5,26.5,0,0,0-10-2.6,8.45,8.45,0,0,0-3.75.47,4.81,4.81,0,0,0-2.26,2.43,8.29,8.29,0,0,0-7.35-1.17c-2.76.74-5.9,2.23-7.11,4.81a8.09,8.09,0,0,0-.21,6.11c.53,1.68,2.31,4.32,4,3.7",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "303.448px 91.3535px"
    },
    id: "elo4z034ebwdq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.74,151.43h0a12.35,12.35,0,0,1-12.08-13c.17-3.45.33-6.24.33-6.24s-9.42-1.22-9.77-10.6.74-30.94.74-30.94h0A32.6,32.6,0,0,1,319.81,94l1.41,1-.87,44.31A12.36,12.36,0,0,1,307.74,151.43Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "303.685px 119.561px"
    },
    id: "elq68bk2sqzx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296,132.09a21.86,21.86,0,0,0,12.14-3.78s-2.89,7.27-12.27,6.66Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "302.005px 131.658px"
    },
    id: "el8gu989hkj55",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.31,104.75c.16-.07,6.4-2.07,6.35,4.35s-6.47,5.05-6.48,4.86S320.31,104.75,320.31,104.75Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "323.42px 109.306px"
    },
    id: "el1r8jxzsdmnt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.15,111.54s.12.08.3.17a1.08,1.08,0,0,0,.84,0,2.75,2.75,0,0,0,1.3-2.47,3.6,3.6,0,0,0-.31-1.6,1.27,1.27,0,0,0-.83-.86.56.56,0,0,0-.66.3c-.09.18-.05.3-.08.31s-.14-.1-.09-.37a.73.73,0,0,1,.26-.4.89.89,0,0,1,.62-.16,1.6,1.6,0,0,1,1.16,1,3.68,3.68,0,0,1,.37,1.79,2.91,2.91,0,0,1-1.65,2.76,1.23,1.23,0,0,1-1-.18C322.16,111.7,322.13,111.56,322.15,111.54Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "323.589px 109.251px"
    },
    id: "el4068z6easjf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.39,105.32a1.35,1.35,0,0,0,1.33,1.32,1.28,1.28,0,0,0,1.35-1.24,1.34,1.34,0,0,0-1.33-1.32A1.29,1.29,0,0,0,289.39,105.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "290.73px 105.36px"
    },
    id: "elpocgh0zupq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.06,103.82c.17.17,1.17-.6,2.61-.63s2.52.66,2.67.48-.1-.39-.57-.72a3.7,3.7,0,0,0-2.14-.6,3.52,3.52,0,0,0-2.07.73C289.12,103.43,289,103.75,289.06,103.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "291.715px 103.096px"
    },
    id: "el2gz8t5apb5j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.51,105.31a1.35,1.35,0,0,0,1.33,1.31,1.27,1.27,0,0,0,1.35-1.24,1.34,1.34,0,0,0-1.32-1.32A1.3,1.3,0,0,0,303.51,105.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "304.85px 105.341px"
    },
    id: "elyls928r1n1t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.23,103.74c.18.17,1.17-.61,2.61-.64s2.52.66,2.67.48-.1-.39-.57-.71a3.65,3.65,0,0,0-2.14-.61,3.52,3.52,0,0,0-2.07.73C303.29,103.34,303.15,103.66,303.23,103.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "305.881px 103.011px"
    },
    id: "el8cz8iscn4je",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.27,114.55a9.71,9.71,0,0,0-2.35-.36c-.37,0-.72-.09-.79-.34a2,2,0,0,1,.22-1.1c.33-.9.67-1.84,1-2.83,1.41-4,2.42-7.33,2.26-7.39s-1.44,3.17-2.85,7.19l-1,2.85a2.13,2.13,0,0,0-.16,1.45,1,1,0,0,0,.62.52,2.52,2.52,0,0,0,.63.07A8.89,8.89,0,0,0,298.27,114.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "296.583px 108.597px"
    },
    id: "elbfuwjp8ieew",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.54,115.45c-.24,0-.2,1.55-1.51,2.7s-3,1-3,1.23.38.29,1.09.29a3.86,3.86,0,0,0,2.49-.94,3.39,3.39,0,0,0,1.17-2.26C302.83,115.82,302.65,115.43,302.54,115.45Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "300.409px 117.56px"
    },
    id: "el2xpclycqjqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.72,98.1c.15.39,1.59.17,3.28.33s3.08.58,3.29.23c.1-.17-.15-.54-.71-.9a5.44,5.44,0,0,0-2.45-.79,5.54,5.54,0,0,0-2.56.36C303,97.6,302.66,97.91,302.72,98.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "306.012px 97.8701px"
    },
    id: "elbq88egeo45u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.49,99.64c.26.32,1.24,0,2.44-.09s2.21.16,2.43-.18c.1-.17-.07-.5-.52-.8a3.53,3.53,0,0,0-3.92.23C289.5,99.14,289.37,99.48,289.49,99.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "291.918px 98.9313px"
    },
    id: "elm2pu16hjubk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.72,95.74c-.06,2.74.63,5.77.21,8.46-.06.41-1.08,1.52-1.17,1.92-.49,2.39-1.45,3.43-2.92,1-.57-.93-1-3.54-1.22-4.6l-1.92-8.61a15.07,15.07,0,0,1-7.09,1.87,7.29,7.29,0,0,1-6.18-3.45,7.57,7.57,0,0,1-11.7,1.84,3.15,3.15,0,0,1-4.15,1,3.75,3.75,0,0,1-1.63-4.1c.59-2.3,3-3.6,5.27-4.33,8.85-2.85,18.77-1,26.9,3.46a13.6,13.6,0,0,1,3.3,2.36c.94,1,2.24,2.12,2.31,3.48",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "302.95px 96.9424px"
    },
    id: "el9mo01i8r0a5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,95a4.58,4.58,0,0,1,1.45.23,4.92,4.92,0,0,1,1.34.86c.46.4.91.92,1.46,1.43a4.8,4.8,0,0,0,1.82,1.15,3.26,3.26,0,0,0,1.78,0c1-.28,1.38-.82,1.34-.86a10.06,10.06,0,0,1-1.42.48,3.09,3.09,0,0,1-1.54-.13,4.53,4.53,0,0,1-1.61-1.06c-.52-.49-1-1-1.5-1.42a4.63,4.63,0,0,0-1.54-.84C315.55,94.56,314.93,95,315,95Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "319.594px 96.7703px"
    },
    id: "el164a4nx5orh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.07,97.8c0,.08.48,0,1,.45a5.72,5.72,0,0,1,.82.93,4.18,4.18,0,0,0,1.22,1.13,4.39,4.39,0,0,0,2.92.62c.77-.12,1.17-.4,1.14-.46s-.47.06-1.18.07a4.69,4.69,0,0,1-2.59-.7c-.92-.51-1.38-1.49-2.11-1.91S316,97.73,316.07,97.8Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "319.618px 99.3257px"
    },
    id: "elxoe648n0cd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.34,79.56s-.31-.08-.83.08a3.54,3.54,0,0,0-1.8,1.36c-1.15,1.61-1.42,4.46-.53,7.23a10.21,10.21,0,0,0,4.6,5.65,8.91,8.91,0,0,0,2.05.87,2.14,2.14,0,0,0,.81.14A28.38,28.38,0,0,1,293,93.54a10.36,10.36,0,0,1-4.27-5.49c-.85-2.61-.65-5.34.32-6.84a3.66,3.66,0,0,1,1.56-1.37C291.05,79.63,291.34,79.61,291.34,79.56Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "291.645px 87.2153px"
    },
    id: "elfk8ctbqtwl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.57,83.45a4.15,4.15,0,0,0,.08,1.81,11.21,11.21,0,0,0,4.75,7.14,4.18,4.18,0,0,0,1.64.78A18.43,18.43,0,0,1,285.77,89C283.9,86.24,283.75,83.42,283.57,83.45Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "286.773px 88.3149px"
    },
    id: "elnie3tpoqnr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.86,214.14l-13.72.69a3.26,3.26,0,0,0-3.09,3.3c.07,3.14.6,7.43,3,7l1.56-6.83,11.39,10a8.27,8.27,0,0,0,4.1,2l2.68-.28Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "226.415px 222.22px"
    },
    id: "el38phrpahgs9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.47 140.65 290.3 143.02 286.74 202.57 286.74 255.4 330.77 260.27 331.28 184.09 328.44 146.18 321.71 138.14 297.47 140.65",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "309.01px 199.205px"
    },
    id: "elpoqpiykeols",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.26 143.5 295.26 137.73 321.43 134.09 320.38 147.38 314.37 157.8 304.54 158.35 297.44 153.97 295.26 143.5",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "308.345px 146.22px"
    },
    id: "el3e8lfaiwogm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.61,142.83a6.77,6.77,0,0,1-.15-2.64,7,7,0,0,1,.37-2.62,6.77,6.77,0,0,1,.15,2.64A7,7,0,0,1,297.61,142.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "297.72px 140.2px"
    },
    id: "el3tcrim1kf3j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.15,142.35a8.75,8.75,0,0,1-.09-2.95,8.43,8.43,0,0,1,.44-2.92,8.61,8.61,0,0,1,.08,3A8.24,8.24,0,0,1,304.15,142.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "304.325px 139.415px"
    },
    id: "elbob48mupccf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.48,141.69a9.52,9.52,0,0,1,0-3.12,9.4,9.4,0,0,1,.49-3.08,9.86,9.86,0,0,1,0,3.12A9.72,9.72,0,0,1,310.48,141.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "310.723px 138.59px"
    },
    id: "el80gbq8krs3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.56,140.69a12,12,0,0,1,.27-5.87,10.93,10.93,0,0,1,0,2.94A11.18,11.18,0,0,1,316.56,140.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "316.623px 137.755px"
    },
    id: "el9fp3z6rzxhc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.65,165.86a3.78,3.78,0,0,1-.35,1c-.25.62-.64,1.5-1.15,2.58-1,2.15-2.53,5.08-4.39,8.2s-3.71,5.86-5.12,7.78c-.7,1-1.28,1.73-1.7,2.25a4.15,4.15,0,0,1-.7.77,35.37,35.37,0,0,1,2.1-3.23c1.33-2,3.12-4.72,5-7.83s3.41-6,4.51-8.11A37,37,0,0,1,313.65,165.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "306.945px 177.15px"
    },
    id: "el8ue6uy8899h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.58,137.21l7.1,3.42L342.4,144a11.43,11.43,0,0,1,9.38,12.71l-7.19,56,8.58,54.3-34-1-2-20.2v-56Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "335.17px 202.11px"
    },
    id: "el9pose6vpvi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.17,202.71a4.81,4.81,0,0,1,.1-.7c.1-.5.23-1.15.39-2l1.51-7.22,5.19-23.77c.57-2.55,1.12-5,1.65-7.42l.07.24-2.36-2.47-.13-.14.1-.16,3.95-6.57v.19l-4.36-10.56c-.49-1.23-.89-2.22-1.18-3a6.91,6.91,0,0,1-.38-1.06,5.44,5.44,0,0,1,.5,1l1.3,2.91L328,152.55l.05.1-.06.1c-1.21,2-2.52,4.25-3.91,6.61l0-.3,2.36,2.45.1.1,0,.13c-.53,2.39-1.08,4.87-1.64,7.42-2.08,9.25-4,17.62-5.34,23.74-.69,3-1.26,5.43-1.67,7.19l-.48,1.94A3.48,3.48,0,0,1,317.17,202.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "322.61px 170.39px"
    },
    id: "eld4aqegu2yh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.44,211.88l30.08-16.77,14.57-39.31a21.13,21.13,0,0,1,11.67-12.14l3.87-1.61,0,103.49.77,24.52-16.3-4.88,8.32-49.28-2.88-24.25-2.85,11.73a15.9,15.9,0,0,1-7.43,10L241,229.62Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "262.92px 206.055px"
    },
    id: "eldkpzo8ffrif",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.8 212.64 230.27 213.4 237.39 230.38 240.71 229.09 232.8 212.64",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "235.49px 221.51px"
    },
    id: "el796wlp3p0r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,202.09a21.9,21.9,0,0,0-2.25-3.81,22.33,22.33,0,0,0-3.33-2.91,8.42,8.42,0,0,1,5.58,6.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "265.21px 198.73px"
    },
    id: "elnu55d8p7008",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.05,212.1c0,.07-.15.2-.17.49s.17.63.57.51a.43.43,0,0,0,.2-.73c-.17-.24-.39-.25-.4-.33s.28-.22.66.06a.9.9,0,0,1,.34.73.88.88,0,0,1-.65.77.85.85,0,0,1-1.08-1.09C235.69,212.06,236,212,236.05,212.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "236.36px 212.79px"
    },
    id: "eldy4ydt0dggt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.47,211.08c0,.07-.15.2-.16.49s.17.63.57.51a.44.44,0,0,0,.2-.74c-.17-.23-.39-.25-.41-.32s.28-.23.67.06a.88.88,0,0,1,.34.72.92.92,0,0,1-1.63.48.91.91,0,0,1-.1-.8C238.12,211,238.47,211,238.47,211.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "238.79px 211.767px"
    },
    id: "eltamxm3mydi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.63,204.3a2.73,2.73,0,0,1-.13-.63c-.07-.48-.17-1.09-.28-1.85-.23-1.67-.54-4-.92-6.79-.74-5.8-1.74-13.71-2.85-22.44-.15-1.24-.3-2.46-.45-3.67v-.06l0-.06c.76-1.93,1.5-3.8,2.2-5.59v.19c-.76-1.73-1.49-3.39-2.17-5l0-.07,0-.08c1.34-4.81,2.46-8.86,3.26-11.78.4-1.38.72-2.48.95-3.3a7.64,7.64,0,0,1,.39-1.16,7.93,7.93,0,0,1-.25,1.19c-.2.83-.48,1.95-.83,3.34-.76,2.93-1.82,7-3.07,11.83l0-.15,2.21,4.94,0,.09,0,.1L288.5,169v-.13c.15,1.2.3,2.43.46,3.67,1,8.74,2,16.65,2.69,22.45.32,2.83.58,5.14.76,6.82l.18,1.85A2.66,2.66,0,0,1,292.63,204.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "290.317px 173.155px"
    },
    id: "elfn0a4x3nbli",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.39,216.19a2.59,2.59,0,0,1-.1-.49c-.05-.38-.12-.85-.2-1.41-.16-1.31-.37-3.07-.64-5.21-.53-4.4-1.28-10.47-2.18-17.17s-1.78-12.76-2.42-17.14c-.31-2.13-.57-3.89-.76-5.19-.07-.57-.13-1-.18-1.42a1.59,1.59,0,0,1,0-.5,2.44,2.44,0,0,1,.13.48c.08.38.17.84.28,1.4.23,1.22.55,3,.92,5.17.74,4.37,1.68,10.42,2.58,17.13s1.59,12.79,2,17.2c.22,2.2.38,4,.48,5.22,0,.57.07,1,.09,1.43A1.59,1.59,0,0,1,285.39,216.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "282.15px 191.925px"
    },
    id: "elk0307dqe6xm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.24,253a4.17,4.17,0,0,0,.69.84,3.2,3.2,0,0,0,2.75.62,4.64,4.64,0,0,0,3-2.93,18.12,18.12,0,0,0,.84-5.38,12.3,12.3,0,0,0-.55-5.37,9.82,9.82,0,0,0-2.73-3.44,12.75,12.75,0,0,1-2.08-2.27,2.6,2.6,0,0,1-.49-1s.21.34.65.9a15.75,15.75,0,0,0,2.17,2.12,9.67,9.67,0,0,1,2.92,3.53,12.21,12.21,0,0,1,.63,5.58,17.75,17.75,0,0,1-.91,5.53,5,5,0,0,1-3.34,3.1,3.27,3.27,0,0,1-3-.82,2.43,2.43,0,0,1-.49-.7C281.24,253.08,281.22,253,281.24,253Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "285.18px 244.493px"
    },
    id: "elrdsadn4x31b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.06,214.14s1-11.47,10.08-12.53C280.14,201.61,280.31,211,270.06,214.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "275.1px 207.875px"
    },
    id: "eltco02y1mve9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.74,257.09l26.45,17.3,3-2.39,1.41-38.77-25.19-19.09-3.46,1.19Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "334.17px 244.265px"
    },
    id: "elt8l564imkqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.12 214.69 325.15 256.65 319.59 256.65 321.45 215.52 324.12 214.69",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "322.37px 235.67px"
    },
    id: "elwssczeptsmo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.44,266.29a3.25,3.25,0,0,0,3,2,.34.34,0,0,1,.22.19,3,3,0,0,0,2.51,1.56,5.36,5.36,0,0,0,2.84-.82c1.38-.84,3.84-6.36,3.84-6.36l5.83-13-9.8-2.65-12.46,3.88c0,.23-2.92,12-2.92,12a3,3,0,0,0,3.5-1.86,32.26,32.26,0,0,1,2.2-4.12l.93,5.31-3.55,1.21a2.36,2.36,0,0,0,1.52,2.7Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "338.09px 258.625px"
    },
    id: "elql82x9cudjn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.84,175.06l16.33,30.06-13.29,39.45,14.77,8.33L373.44,209a12.49,12.49,0,0,0-.16-10.16l-23-49.49Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "355.641px 201.125px"
    },
    id: "elbdut77k1w4l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.88 244.57 338.5 247.63 352.44 255.15 353.9 252.47 339.88 244.57",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "346.2px 249.86px"
    },
    id: "eljp3rjxmmyi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.88,244.57s0-.07,0-.2.1-.34.17-.58l.71-2.23c.65-2,1.57-4.79,2.71-8.29,2.36-7.08,5.65-16.94,9.41-28.23l0,.21c-1.9-3.23-3.86-6.64-5.83-10.16-3.6-6.43-6.9-12.63-9.73-18.36-1.4-2.87-2.7-5.61-3.8-8.24a16.43,16.43,0,0,1-1.36-7.79,17.88,17.88,0,0,1,1.45-6.37,12.48,12.48,0,0,1,2.89-4,9.49,9.49,0,0,1,2.6-1.72,5.86,5.86,0,0,1,1-.37,11.47,11.47,0,0,0-3.48,2.24,12.2,12.2,0,0,0-2.76,4,17.84,17.84,0,0,0-1.36,6.27,16.28,16.28,0,0,0,1.39,7.6c1.12,2.61,2.43,5.34,3.84,8.2,2.84,5.71,6.16,11.89,9.76,18.31,2,3.52,3.91,6.93,5.8,10.16l.06.1,0,.11c-3.84,11.27-7.18,21.11-9.59,28.17L341,241.62c-.34.93-.6,1.66-.79,2.2l-.22.57A1.31,1.31,0,0,1,339.88,244.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "342.735px 196.405px"
    },
    id: "eliz0nggo6hgg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.21,204.84a12.29,12.29,0,0,1-1.61-.57,11.51,11.51,0,0,0-7.93.25,11.81,11.81,0,0,1-1.57.67,3.8,3.8,0,0,1,1.42-1,9.86,9.86,0,0,1,4.08-1,9.76,9.76,0,0,1,4.13.76A3.82,3.82,0,0,1,364.21,204.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "358.655px 204.187px"
    },
    id: "elcu3u4z2vrcj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.57 167.91 345.3 207.17 346.96 194.26 333.57 167.91",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "340.265px 187.54px"
    },
    id: "el5rxtjipvzmn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,245.05c0,.07-.15.2-.16.49s.17.63.57.51a.44.44,0,0,0,.2-.74c-.17-.23-.39-.25-.4-.32s.27-.22.66.06a.88.88,0,0,1,.34.73.89.89,0,0,1-.66.77.87.87,0,0,1-1-.3.89.89,0,0,1-.1-.79C352.6,245,353,245,353,245.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "353.305px 245.745px"
    },
    id: "elwtn6ypo7i6j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.13,242.22c0,.07-.15.2-.16.5a.45.45,0,1,0,.77-.23c-.17-.24-.4-.25-.41-.33s.28-.22.67.06a.9.9,0,0,1,.34.73.89.89,0,1,1-1.73-.32C353.78,242.18,354.13,242.15,354.13,242.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "354.45px 242.933px"
    },
    id: "els0hlqqk5h28",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.18,192.21c-1.75.92-2.36,3.5-2.16,5.47s.93,3.88.88,5.85a24.82,24.82,0,0,1-.75,4.17,7.13,7.13,0,0,0,.12,4.17,3.2,3.2,0,0,0,3.31,2.09l1.39-2.8a15.43,15.43,0,0,0-.2-14.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "371.231px 203.092px"
    },
    id: "eluqjsgsi4kq",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2",
    className: "animable",
    style: {
      transformOrigin: "273.435px 388.18px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.8,403.3c.9-3.11,2.83-6.13,5.8-7.41s6.69-.58,9.86.58,6.29,2.69,9.66,2.9,7.16-1.39,8.17-4.61c.95-3-.87-6.26-3.16-8.46a20,20,0,0,0-32.7,7.85",
    style: {
      fill: "#68A1D6",
      transformOrigin: "471.489px 392.027px"
    },
    id: "el372qf2beh1z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elzh3y0wmppqe"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "471.489px 392.027px"
    },
    className: "animable",
    id: "elvomnd8lwakh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.8,403.3c.9-3.11,2.83-6.13,5.8-7.41s6.69-.58,9.86.58,6.29,2.69,9.66,2.9,7.16-1.39,8.17-4.61c.95-3-.87-6.26-3.16-8.46a20,20,0,0,0-32.7,7.85",
    id: "elzo2we88sgva",
    className: "animable",
    style: {
      transformOrigin: "471.489px 392.027px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M429.12,416.83c-4.94-4.69-4.69-12.86-2.23-19.22s7.84-11.23,13.85-14.44A43.84,43.84,0,0,1,479,381.93a18.15,18.15,0,0,0-14.68,8.61c-2.7,4.5-3.31,10-5.54,14.7a23.15,23.15,0,0,1-29.64,11.59",
    style: {
      fill: "#68A1D6",
      transformOrigin: "452.09px 398.328px"
    },
    id: "el2a9wvlwttry",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.74,388.63c-5.47-6.46-6.19-16.82-5.39-25.25s2.76-16.9,1.43-25.26c-.79-4.95-2.71-9.67-3.36-14.65s.27-10.59,4.13-13.8c4.42-3.69,11.4-2.82,16,.65s7.28,8.9,9.23,14.32c4.28,11.92,5.85,25.13,2.33,37.29s-11.77,23-23.89,26.7",
    style: {
      fill: "#68A1D6",
      transformOrigin: "436.139px 347.955px"
    },
    id: "elrztozzosi6o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.12,441.61a4.25,4.25,0,0,1,0-.74c0-.49,0-1.21,0-2.14.07-1.85.25-4.53.66-7.82a105.86,105.86,0,0,1,2.1-11.45,53,53,0,0,1,5.23-13.26,55.49,55.49,0,0,1,8.54-11.42,54.74,54.74,0,0,1,8.95-7.44c1.37-.95,2.69-1.66,3.83-2.33s2.18-1.11,3-1.52l2-.82a3.59,3.59,0,0,1,.69-.26,4.9,4.9,0,0,1-.66.34l-1.93.9c-.82.43-1.82,1-3,1.58s-2.42,1.42-3.77,2.37a56.36,56.36,0,0,0-17.28,18.82c-5,8.8-6.4,18.05-7.4,24.53-.45,3.28-.68,5.95-.81,7.79l-.12,2.13A5.31,5.31,0,0,1,424.12,441.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "441.612px 412.01px"
    },
    id: "ell450yvlpp29",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.94,363.16c-10.12,6.11-10.09,11.66-8.4,16.91s7.9,8.89,13,6.93c2.91-1.11,5-3.64,6.82-6.19s3.49-5.26,6-7.09,6.18-2.52,8.72-.71",
    style: {
      fill: "#68A1D6",
      transformOrigin: "385.388px 375.349px"
    },
    id: "el6b74st6ioo8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1ro8m5qomjr"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      transformOrigin: "385.388px 375.349px"
    },
    className: "animable",
    id: "el7ybklux5ihq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.94,363.16c-10.12,6.11-10.09,11.66-8.4,16.91s7.9,8.89,13,6.93c2.91-1.11,5-3.64,6.82-6.19s3.49-5.26,6-7.09,6.18-2.52,8.72-.71",
    id: "el05dup3kcs2rb",
    className: "animable",
    style: {
      transformOrigin: "385.388px 375.349px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M369.36,369.85c2.65-3.65,9.18-4.71,13.31-2.89s7.15,5.45,9.86,9.06,5.34,7.42,9.09,9.94,9,3.42,12.72.89a10.93,10.93,0,0,0,4.33-7.49,25,25,0,0,0-.6-8.82c-.89-4.24-2.35-8.68-5.75-11.37-3.78-3-9-3.15-13.87-3-5.54.18-11.17.59-16.37,2.51s-10.51,6.08-12.72,11.16",
    style: {
      fill: "#68A1D6",
      transformOrigin: "394.09px 372.244px"
    },
    id: "el1ng6wjytqe3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.71,433.51a.72.72,0,0,1,0-.23l0-.65c0-.61,0-1.45-.09-2.51-.07-2.22-.16-5.37-.27-9.24s-.28-8.54-.56-13.69-.67-10.81-1.45-16.7A53.48,53.48,0,0,0,411.6,382a45,45,0,0,0-7-13.57,40.53,40.53,0,0,0-4.28-4.69,31.21,31.21,0,0,0-7.57-5.16c-.49-.23-.93-.45-1.31-.61l-1-.38-.61-.25-.2-.09.22.05.62.2,1,.35c.39.14.83.35,1.33.57a30.32,30.32,0,0,1,7.72,5.09,38.4,38.4,0,0,1,4.35,4.69,42.4,42.4,0,0,1,4,6.18,44.11,44.11,0,0,1,3.16,7.49,53.92,53.92,0,0,1,1.7,8.55c.78,5.91,1.15,11.58,1.42,16.74s.38,9.8.46,13.7.11,7.06.12,9.24c0,1.07,0,1.91,0,2.52,0,.26,0,.48,0,.65S415.71,433.51,415.71,433.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "402.68px 395.38px"
    },
    id: "elx43yimkon5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.35,438.08a28.42,28.42,0,0,1-1.11-4.35,45.53,45.53,0,0,1-.46-12.21,81.14,81.14,0,0,1,3.85-17.71c2.08-6.52,4.9-13.48,7.31-21a98.3,98.3,0,0,0,2.91-11.09,99.3,99.3,0,0,0,1.43-10.58,153.08,153.08,0,0,0,.32-18.1c-.17-5.15-.45-9.32-.62-12.2-.08-1.42-.15-2.53-.19-3.32,0-.36,0-.64,0-.86a1.13,1.13,0,0,1,0-.3,1.36,1.36,0,0,1,0,.29c0,.22,0,.51.09.87.07.78.16,1.89.28,3.31.22,2.87.55,7,.76,12.2a149.74,149.74,0,0,1-.22,18.14,100.07,100.07,0,0,1-1.42,10.63A94,94,0,0,1,429.37,383c-2.42,7.51-5.25,14.47-7.34,20.95a82.37,82.37,0,0,0-3.93,17.62,47.14,47.14,0,0,0,.31,12.15c.25,1.42.48,2.52.68,3.25.08.35.15.63.2.84A1.09,1.09,0,0,1,419.35,438.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "425.831px 382.22px"
    },
    id: "eloozy4wu56b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.44 442.65 396.92 442.65 395.83 433.5 444.44 433.5 444.44 442.65",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "420.135px 438.075px"
    },
    id: "elbizomcqb9p9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.02 441.61 407.96 469.05 433.78 469.05 439.34 441.61 402.02 441.61",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "420.68px 455.33px"
    },
    id: "elr1kvk34h59m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.44,442.65c0,.13-10.45.2-23.33.16s-23.34-.16-23.34-.29,10.45-.2,23.34-.16S444.44,442.53,444.44,442.65Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "421.105px 442.585px"
    },
    id: "elazgimm1rg4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.28,456.2a19,19,0,0,0-4.18-2.4,14.68,14.68,0,0,0-5.09-1,17.81,17.81,0,0,0-6.26,1.14c-2.16.74-4.19,1.59-6.16,2.06a14.91,14.91,0,0,1-5.32.16,11.18,11.18,0,0,1-3.42-1.08,7.49,7.49,0,0,1-.82-.53c-.18-.13-.27-.21-.26-.22s.4.23,1.16.59a12.16,12.16,0,0,0,3.39.92,14.79,14.79,0,0,0,5.18-.25c1.9-.47,3.93-1.34,6.11-2.08a17.72,17.72,0,0,1,6.41-1.13,14.58,14.58,0,0,1,5.2,1.14,13.17,13.17,0,0,1,3.1,1.81,8.8,8.8,0,0,1,.73.63C436.22,456.1,436.29,456.18,436.28,456.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "420.525px 454.353px"
    },
    id: "elxfcdftu667",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.92,458a20.29,20.29,0,0,0-4-2.37,13.63,13.63,0,0,0-4.9-1,17.8,17.8,0,0,0-6.06,1.09c-2.09.7-4.05,1.51-5.93,2a15.22,15.22,0,0,1-5.12.57,8.6,8.6,0,0,1-3.35-.9,5.82,5.82,0,0,1-.8-.5c-.17-.13-.26-.21-.25-.22s.4.23,1.13.56a9,9,0,0,0,3.29.74,15.56,15.56,0,0,0,5-.66c1.83-.51,3.78-1.33,5.9-2a17.72,17.72,0,0,1,6.21-1.08,13.41,13.41,0,0,1,5,1.14,13.63,13.63,0,0,1,3,1.79c.32.26.55.47.7.62S435.93,458,435.92,458Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "420.715px 456.273px"
    },
    id: "elxv75ehkrh8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.75,454.38a21.64,21.64,0,0,0-4.29-2.54,15.88,15.88,0,0,0-5.22-1.25,17,17,0,0,0-6.46,1.14,57.36,57.36,0,0,1-6.37,2.08,16.33,16.33,0,0,1-5.5,0,12.31,12.31,0,0,1-3.53-1.12,6.19,6.19,0,0,1-.86-.53c-.18-.14-.27-.22-.26-.23s.41.25,1.2.6a13.47,13.47,0,0,0,3.5,1,16.3,16.3,0,0,0,5.37-.1,62.88,62.88,0,0,0,6.31-2.1,16.85,16.85,0,0,1,6.63-1.13,16,16,0,0,1,8.49,3.29,9.2,9.2,0,0,1,.76.66C436.68,454.28,436.77,454.37,436.75,454.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "420.506px 452.286px"
    },
    id: "elo1656rit8c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.86,442.69c0,.13-10.69.23-23.87.23s-23.88-.1-23.88-.23,10.69-.22,23.88-.22S444.86,442.57,444.86,442.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "420.985px 442.695px"
    },
    id: "elcwppvylirl5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.71,432.25c1.71,2.44,5,1.63,6.58.14s2.19-3.64,2.78-5.7c1.35-4.71,2.72-9.65,1.71-14.44a8,8,0,0,0-1.84-3.92A4.19,4.19,0,0,0,87,407c-1.68.44-2.72,2.08-3.47,3.64a34.47,34.47,0,0,0-3.4,14.77,11.92,11.92,0,0,0,1.61,6.83",
    style: {
      fill: "#68A1D6",
      transformOrigin: "86.6161px 420.363px"
    },
    id: "el8cwqelt2aw3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltyh8zha9p1r"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "86.6161px 420.363px"
    },
    className: "animable",
    id: "ele6n9knskeb4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.71,432.25c1.71,2.44,5,1.63,6.58.14s2.19-3.64,2.78-5.7c1.35-4.71,2.72-9.65,1.71-14.44a8,8,0,0,0-1.84-3.92A4.19,4.19,0,0,0,87,407c-1.68.44-2.72,2.08-3.47,3.64a34.47,34.47,0,0,0-3.4,14.77,11.92,11.92,0,0,0,1.61,6.83",
    id: "elhytuloqglwt",
    className: "animable",
    style: {
      transformOrigin: "86.6161px 420.363px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M88.12,444.61a14.77,14.77,0,0,1,9.19-1.11,7.64,7.64,0,0,1,4.54,2c1.13,1.26,1.35,3.46,0,4.54a4.34,4.34,0,0,1-2.86.72c-2.43,0-5.12-.45-7.06,1-1.11.83-1.85,2.22-3.17,2.63a3.15,3.15,0,0,1-3.45-1.53,5.39,5.39,0,0,1-.38-3.95A6,6,0,0,1,88.12,444.61Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "93.7502px 448.84px"
    },
    id: "elk6kmvqufv5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,435.75a8.85,8.85,0,0,0,1.38-8.17,15.66,15.66,0,0,0-4.84-7,26,26,0,0,0-8.67-5.12,9.17,9.17,0,0,0-3.9-.66,4.1,4.1,0,0,0-3.27,2c-.91,1.74,0,3.85.91,5.57A65.72,65.72,0,0,0,64.32,431c1.71,2.2,3.67,4.37,6.27,5.37s5.3.88,6.68-.93",
    style: {
      fill: "#68A1D6",
      transformOrigin: "68.0759px 425.892px"
    },
    id: "ela566xcjcjbh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6,469.08a5.86,5.86,0,0,0,.15-1.11c.08-.81.18-1.83.3-3a41.88,41.88,0,0,1,.68-4.44,33.72,33.72,0,0,1,1.61-5.24A19.22,19.22,0,0,1,87,450.52a10,10,0,0,1,3.38-2.82,9.37,9.37,0,0,1,2.85-.88,6.28,6.28,0,0,0,1.11-.16,4.5,4.5,0,0,0-1.13,0,8.7,8.7,0,0,0-3,.77,10,10,0,0,0-3.57,2.84,18.86,18.86,0,0,0-2.77,4.84,31.44,31.44,0,0,0-1.6,5.32,36.77,36.77,0,0,0-.59,4.5c-.1,1.28-.14,2.33-.15,3A5.25,5.25,0,0,0,81.6,469.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "87.9318px 457.852px"
    },
    id: "elzc2vol7bacf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.81,466.75a3.52,3.52,0,0,0,0-.52c0-.39,0-.87,0-1.47,0-1.28,0-3.13.07-5.41.11-4.56.5-10.87,1.26-17.79s1.78-13.16,2.71-17.63c.21-1.13.43-2.13.64-3s.37-1.65.53-2.26l.34-1.43a1.65,1.65,0,0,0,.09-.51,2.56,2.56,0,0,0-.17.48c-.12.37-.26.84-.43,1.41s-.39,1.37-.61,2.25-.47,1.89-.71,3a166.8,166.8,0,0,0-2.84,17.65c-.76,6.94-1.1,13.26-1.14,17.84,0,2.28,0,4.14.08,5.41q.06.9.09,1.47A2,2,0,0,0,81.81,466.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "84.5px 441.74px"
    },
    id: "elly6qvjuutva",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.84,454.56a11.34,11.34,0,0,0,0-1.54c-.06-1-.2-2.42-.47-4.17A56.37,56.37,0,0,0,80,442.78a52.3,52.3,0,0,0-2.54-7.18A38.15,38.15,0,0,0,70,424a18,18,0,0,0-1.75-1.63c-.27-.23-.51-.46-.75-.64l-.68-.46a9.13,9.13,0,0,0-1.3-.83,44.81,44.81,0,0,1,4.25,3.78A40.08,40.08,0,0,1,77,435.79a57.67,57.67,0,0,1,2.56,7.11c.66,2.23,1.1,4.28,1.44,6s.5,3.14.61,4.12A10,10,0,0,0,81.84,454.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "73.6931px 437.5px"
    },
    id: "elh6ugt3fj1lm",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2",
    className: "animable",
    style: {
      transformOrigin: "229.271px 81.5136px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.29,50.41a2.45,2.45,0,0,1,.51,0l1.5,0a16,16,0,0,1,2.42.23c.48.08,1,.13,1.54.24l1.73.43a28,28,0,0,1,8.32,3.72,28.92,28.92,0,0,1,8.92,38.73,29.15,29.15,0,0,1-13.9,12.09,28.23,28.23,0,0,1-9.64,2.12,27.58,27.58,0,0,1-10.08-1.25l-.3-.1h.23l-16.85,5.84-.68.24.21-.7,4.38-14,.07.34a28.86,28.86,0,0,1-6.76-25A28.34,28.34,0,0,1,205.26,63a28.72,28.72,0,0,1,6.67-7,25.88,25.88,0,0,1,6.85-3.79,22.35,22.35,0,0,1,3-1,18.91,18.91,0,0,1,2.6-.54c.79-.11,1.49-.23,2.09-.28l1.54-.05H229a1,1,0,0,1,.32,0,2.11,2.11,0,0,1-.32.05l-.93.07-1.52.11c-.6.07-1.29.2-2.07.33a18.79,18.79,0,0,0-2.56.59,21.84,21.84,0,0,0-3,1,33,33,0,0,0-3.29,1.55,29.75,29.75,0,0,0-3.42,2.27,28.88,28.88,0,0,0-6.5,6.91,27.88,27.88,0,0,0-4.2,10.21,28.26,28.26,0,0,0,6.7,24.37l.14.15-.06.19q-2.09,6.75-4.35,14l-.47-.45L220.3,106l.12,0,.12,0,.29.09a27.05,27.05,0,0,0,9.82,1.22,27.76,27.76,0,0,0,9.4-2.05,28.51,28.51,0,0,0,13.59-11.77,28.5,28.5,0,0,0-8.57-38,28.54,28.54,0,0,0-8.16-3.78l-1.7-.46c-.54-.12-1.05-.18-1.52-.27a15.91,15.91,0,0,0-2.4-.3l-1.49-.12A3.34,3.34,0,0,1,229.29,50.41Z",
    style: {
      fill: "#68A1D6",
      transformOrigin: "229.271px 81.5136px"
    },
    id: "el86uwkp4afap",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.35 81.15 216.78 76.71 225.33 84.31 242.12 68.16 246.23 72.6 224.7 92.86 212.35 81.15",
    style: {
      fill: "#68A1D6",
      transformOrigin: "229.29px 80.51px"
    },
    id: "elf552hck7aoe",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSettlement);
export default __webpack_public_path__ + "static/media/NewSettlement.6cba337f.svg";
export { ForwardRef as ReactComponent };